import controller from './vd-radio-group.controller'

const RadioGroupComponent = {
  require: {
    ngModelCtrl: 'ngModel',
  },
  template: '<div class="vd-radio-group" ng-transclude></div>',
  transclude: true,
  controller,
}

export default RadioGroupComponent
